import { useTranslation } from 'next-i18next'

export default function OracleFollowUpMessage({ onDismiss }: { onDismiss: () => void }): React.ReactElement {
  const { t } = useTranslation('chatAi')

  return (
    <div
      className="fixed bottom-26 left-0 right-0 mx-auto w-fit max-w-48 bg-white/90 text-purple-darker text-sm font-medium text-center px-3 py-2 rounded-3 shadow-lg cursor-pointer z-oracle"
      onClick={onDismiss}
    >
      {t('alwaysHereForYou')}
      <div className="absolute bottom-[-7px] left-1/2 -translate-x-1/2 w-0 h-0 border-l-[7px] border-l-transparent border-r-[7px] border-r-transparent border-t-[7px] border-t-white/90" />
    </div>
  )
}
